import React, { useState } from 'react'
import { Button } from 'antd'

import { useTranslationRankmi } from 'helpers/translations.helper'
import { WarningModal } from 'components/ui/modals/warningModal'
import { Buttons } from './styled'

interface ConfirmResetProps {
  show: boolean
  onAccept: () => Promise<void>
  onClose: () => void
  evaluationName?: string
}

export const ConfirmReset: React.FC<ConfirmResetProps> = ({
  show,
  onAccept,
  onClose,
  evaluationName,
}) => {
  const [loading, setLoading] = useState(false)
  const t = useTranslationRankmi({
    prefix: 'administration.monitor.evaluations.resetEvaluation',
  })

  const handleAccept = async () => {
    try {
      setLoading(true)
      await onAccept()
    } finally {
      setLoading(false)
    }
  }

  return (
    <WarningModal show={show} onClose={onClose} title={t('title')} width={600}>
      <div
        style={{
          color: '#363636',
          fontFamily: 'Roboto',
          fontSize: '16px',
          fontStyle: 'normal',
          lineHeight: '24px',
        }}
      >
        <div className="mb-1">
          {t('subtitle')} <strong>"{evaluationName}"</strong>.
        </div>
        <div>
          <div className="mb-2">
            <strong>{t('confirmNote')}</strong>
          </div>
          <ul>
            <li>{t('points.progress')}</li>
            <li>{t('points.recalculate')}</li>
            <li>{t('points.retake')}</li>
          </ul>
          <p>{t('warning')}</p>
        </div>
      </div>
      <Buttons>
        <Button
          className="cancel"
          type="default"
          onClick={onClose}
          disabled={loading}
        >
          {t('buttons.cancel')}
        </Button>
        <Button className="reset" onClick={handleAccept} loading={loading}>
          {t('buttons.reset')}
        </Button>
      </Buttons>
    </WarningModal>
  )
}

export default ConfirmReset
